import React from "react";
import { Helmet } from "react-helmet";

const SEO = () => {
  return (
    <Helmet htmlAttributes={{ lang: "en" }} title='Nicolas Pauletto'></Helmet>
  );
};

export default SEO;
